import { createAction } from '@reduxjs/toolkit';
import { addNamespace } from '@Utils/actions';

export const navigateTo = createAction<string>(addNamespace('navigate'));
export const navigateToResolved = createAction(
	addNamespace('navigate/resolved'),
);
export const navigateToReject = createAction(addNamespace('navigate/reject'));
